import {ga4} from './ga4'

export enum BreadcrumbLevel {
  Debug = 'debug',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Fatal = 'fatal',
}

export enum BreadcrumbType {
  Default = 'default',
  Debug = 'debug',
  Error = 'error',
  Navigation = 'navigation',
  Http = 'http',
  Info = 'info',
  Query = 'query',
  Transaction = 'transaction',
  UI = 'ui',
  User = 'user',
}

type Props = {
  category?: string
  data?: {[key: string]: string | number | boolean}
  level?: BreadcrumbLevel
  message: string
  type?: BreadcrumbType
}

const addTrackingBreadcrumb = (props: Props) => {
  try {
    ga4({
      event: 'tracking_breadcrumb',
      tracking: {
        message: props.message,
        category: props.category,
        data: props.data,
        level: props.level || BreadcrumbLevel.Info,
        type: props.type || BreadcrumbType.Default,
      },
    })
  } catch (error) {
    console.error(error)
  }
}

export default addTrackingBreadcrumb
